import { render, staticRenderFns } from "./ResizableTextArea.vue?vue&type=template&id=e782b660&"
import script from "./ResizableTextArea.vue?vue&type=script&lang=js&"
export * from "./ResizableTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e782b660')) {
      api.createRecord('e782b660', component.options)
    } else {
      api.reload('e782b660', component.options)
    }
    module.hot.accept("./ResizableTextArea.vue?vue&type=template&id=e782b660&", function () {
      api.rerender('e782b660', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/shared/components/ResizableTextArea.vue"
export default component.exports